(function() { window.GUID_fa34245b_bf6b_472d_b2a8_dde0547c4018 = { getGuid: function() { return "fa34245b-bf6b-472d-b2a8-dde0547c4018"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PlayerSearchSorting;
        (function (PlayerSearchSorting) {
            PlayerSearchSorting[PlayerSearchSorting["Name"] = 0] = "Name";
            PlayerSearchSorting[PlayerSearchSorting["Rank"] = 1] = "Rank";
            PlayerSearchSorting[PlayerSearchSorting["CSR"] = 2] = "CSR";
        })(PlayerSearchSorting = Enumeration.PlayerSearchSorting || (Enumeration.PlayerSearchSorting = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PlayerSearchSorting.pre.js.map
